

export class CustomEmailDto implements ICustomEmailDto {
    subject!: string | undefined;
    description!: string | undefined;
    templateName!: string | undefined;
    id!: number;

    constructor(data?: ICustomEmailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.subject = _data["subject"];
            this.description = _data["description"];
            this.templateName = _data["templateName"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CustomEmailDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomEmailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["subject"] = this.subject;
        data["description"] = this.description;
        data["templateName"] = this.templateName;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICustomEmailDto {
    subject: string | undefined;
    description: string | undefined;
    templateName: string | undefined;
    id: number;
}

